import module from 'fan/proyecto/module.js'
import template from './template.html'
import moment from 'moment'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { cloneDeep } from 'lodash'
import { FanProyectoDocumentosPlantillaContenidoService } from '../../../../../services/Proyecto/Documentos/Plantilla/Contenido'
import { FanProyectoDocumentosPlantillasConfiguracionEtiquetasService } from '../../../../../services/Proyecto/Documentos/Plantillas/Configuracion/Etiquetas'

export class FanProyectoDocumentosPlantillaGenerarProcesarComponent {
  idProyecto
  idPlantilla
  nombre
  version
  config
  data
  onClose
  error = null
  procesando = false
  documentosProcesando = []
  documentosPendientes = []
  documentosCompletados = []
  completado = false
  progreso = 0
  pausado = false
  tiempoTranscurrido = 0
  tiempoRestante = ''
  tiempoPromedio = undefined
  comprimiendo = false
  limite = 1
  resultado = null

  constructor ($q, FanProyectoDocumentosPlantillaPdfService) {
    this.$q = $q
    this.FanProyectoDocumentosPlantillaPdfService = FanProyectoDocumentosPlantillaPdfService
  }

  iniciar () {
    this.resultado = cloneDeep(this.data)
    this.procesando = true
    this.total = this.resultado.length
    this.resultado.forEach((item) => (item.error = null))
    this.errores = []
    this.documentos = this.resultado.filter((item) => item.documento)
    this.documentosPendientes = this.resultado.filter((item) => !item.documento)
    this.documentosCompletados = [...this.documentos]
    this.tiempoTranscurrido = 0
    this.tiempoRestante = 'Calculando...'
    this.tiempoPromedio = undefined
    this.siguiente()
  }

  siguiente () {
    if (this.pausado) return

    if (this.documentosProcesando.length >= this.limite) return

    this.progreso = this.documentosCompletados.length / this.total

    if (this.documentosPendientes.length === 0) {
      this.terminar()
      return
    }

    const time = Date.now()
    const procesando = this.documentosPendientes.shift()
    const data = {
      id_colaborador: procesando.data.id_colaborador,
    }

    this.documentosProcesando.push(procesando)

    this.error = null


    console.log(this.config)

    this.FanProyectoDocumentosPlantillaPdfService.post(this.idProyecto, this.idPlantilla, this.version, this.config, data)
      .then(({data}) => {
        procesando.documento = data
        procesando.error = null
        this.documentos.push(procesando)
      })
      .catch(({data}) => {
        procesando.documento = null
        procesando.error = data
        this.errores.push(procesando)
        this.error = procesando.error
        this.pausar('Omitir')
      })
      .finally(() => {
        procesando.time = Date.now() - time
        this.documentosCompletados.push(procesando)
        this.tiempoTranscurrido += procesando.time
        this.tiempoPromedio = this.tiempoTranscurrido / this.documentosCompletados.length
        this.tiempoRestante = moment(0).to(this.tiempoPromedio * this.documentosPendientes.length, true)
        this.documentosProcesando.splice(this.documentosProcesando.indexOf(procesando), 1)
        this.siguiente()
      })

    this.siguiente()
  }

  cerrar (proceso) {
    if (proceso) this.onClose({$event: {detail: this.resultado}})
    else this.onClose({$event: {detail: false}})
  }

  comprimir () {
    if (!this.zip) {
      const zip = new JSZip()
      const filenames = []
      const replace = /^(.*?)\.pdf$/i

      this.documentos.forEach((item) => {
        let {filename, content} = item.documento

        if (filenames.includes(filename)) {
          const basename = filename.replace('.pdf', '')
          const regex = new RegExp(`^${basename} \\((?<numero>\\d+)\\)\\.pdf$`, 'i')
          const maximo = filenames.reduce((numero, name) => {
            const coincide = regex.exec(name)
            return (coincide && coincide.groups.numero > numero) ? +coincide.groups.numero : numero
          }, 0)

          filename = filename.replace(replace, `$1 (${maximo + 1}).pdf`)
        }

        filenames.push(filename)

        zip.file(filename, content)
      })

      this.zip = zip.generateAsync({type: 'blob'})
    }

    return this.zip
  }

  descargar () {
    if (!this.documentos.length) return

    this.comprimiendo = true

    this.$q.all(this.comprimir().then((zip) => saveAs(zip, `${this.nombre}.zip`)))
      .finally(() => (this.comprimiendo = false))
  }

  pausar (mensaje) {
    this.mensaje = mensaje
    this.pausado = !this.pausado
    this.siguiente()
  }

  terminar () {
    this.procesando = false
    this.completado = true
  }
}

module.component('fanProyectoDocumentosPlantillaGenerarProcesar', {
  controller: FanProyectoDocumentosPlantillaGenerarProcesarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idPlantilla: '<',
    version: '<',
    nombre: '<',
    config: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantilla/generar/procesar/component.js